/* eslint-disable no-undef */
import Vue from "vue";
import VueRouter from "vue-router";
import VueRouterBackButton from "vue-router-back-button";
import routes from "./routes/index.js";
import store from "../store";

import isArray from "lodash/isArray";
import get from "lodash/get";
import { runScript } from "@/commons/service/ebsn.js";
import { checkPopup, getFullName } from "@/customEbsn";

import ProductService from "~/service/productService";
import CMSService from "~/service/cmService";

Vue.use(VueRouter);
const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_MODE, // "hash" per Cordova. "History" per Browser
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    //savedPosition funziona solo quando navigo con i tasti del browser e non tramite i link dell'app
    if (savedPosition) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(savedPosition);
        }, 500);
      });
    } else if (to.query.scrollTo) {
      return false; // gestito dall'afterEach
    } else {
      return { x: 0, y: 0 };
    }
  }
});

window.popStateDetected = false;
window.addEventListener("popstate", () => {
  window.popStateDetected = true;
});
const removeTrailingSlash = path => {
  let newPath = path.replace(/(.+)\/$/, "$1");
  return newPath;
};
const setCategory = async (_slug, to) => {
  const slug = isArray(_slug) ? _slug : [_slug];
  //navigation to category

  for (let i = 0; i < slug.length; i++) {
    // resetFilters: "category/resetFilters";
    await store.dispatch("category/resetFilters", slug[i] + to.query.q);
    await store.dispatch("category/setCategory", {
      slug: slug[i],
      query: to.query.q
    });
  }
  let category = store.state.category.category;
  if (category) {
    to.meta.gtm = get(
      category,
      "metaData.category_seo.SEO_TITLE",
      category ? category.name : ""
    );
    runScript(category);
    checkPopup(category);
  }
};
router.beforeEach(async (to, from, next) => {
  const fetchDataAndNext = async function(to, from, next) {
    if (to.meta.slug) {
      await setCategory(to.meta.slug, to, from, next);
    } else if (to.params.pathMatch) {
      await setCategory(to.params.pathMatch, to, from, next);
    } else if (to.params.slug) {
      //navigation to product detailche
      var data = await ProductService.getProductBySlug(to.params.slug);
      if (data) {
        to.params.product = data;
        to.meta.gtm = getFullName(data);
      }
    } else if (to.params.pageName) {
      let data = await CMSService.getPage(to.params.pageName);
      if (data.length > 0) {
        to.params.page = data[0];
        to.meta.gtm = to.params.page.meta.seo_title
          ? to.params.page.meta.seo_title
          : to.params.page.title.rendered;
      }
    } else if (to.meta.pageName) {
      let data = await CMSService.getPage(to.meta.pageName);
      if (data.length > 0) {
        to.params.page = data[0];
        to.meta.gtm = to.params.page.meta.seo_title
          ? to.params.page.meta.seo_title
          : to.params.page.title.rendered;
      }
    } else {
      to.meta.gtm = to.name;
    }
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "content-view",
        "content-name": removeTrailingSlash(to.fullPath),
        "content-view-name": to.meta.gtm,
        "screen-name": to.name
      });
    }
    next();
  };

  let dialog = document.querySelector("div.v-dialog__content");
  if (dialog && dialog.length > 0) {
    const IsItABackButton = window.popStateDetected;
    window.popStateDetected = false;
    if (IsItABackButton) {
      vm.$dialog.clearDialogs();
      next(false);
      return "";
    }
    fetchDataAndNext(to, from, next);
  } else {
    if (to.matched.some(record => record.meta.requiresSsoAuth)) {
      console.log(
        "cart/isSsoAuthenticated",
        store.getters["cart/isSsoAuthenticated"]
      );
      if (
        (store && store.getters["cart/isSsoAuthenticated"] == true) ||
        (await store.dispatch("cart/checkAuthentication"))
      ) {
        if (to.matched.some(record => record.meta.requiresAuth)) {
          if (
            Vue.$cookies.get("X-Ebsn-Session") ||
            Vue.$cookies.get("X-Ebsn-Account") ||
            (await store.dispatch("cart/checkAuthentication"))
          ) {
            fetchDataAndNext(to, from, next);
          } else if (store && store.getters["cart/isAuthenticated"] == false) {
            next({
              name: "login",
              params: {
                redirectParams: {
                  name: to.name,
                  path: to.fullPath,
                  params: to.params
                }
              }
            });
          }
        } else {
          next();
        }
      } else {
        next({
          name: "login",
          params: {
            redirectParams: {
              name: to.name,
              path: to.fullPath,
              params: to.params
            }
          }
        });
      }
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
      if (
        Vue.$cookies.get("X-Ebsn-Session") ||
        Vue.$cookies.get("X-Ebsn-Account") ||
        (await store.dispatch("cart/checkAuthentication"))
      ) {
        fetchDataAndNext(to, from, next);
      } else if (store && store.getters["cart/isAuthenticated"] == false) {
        next({
          name: "login",
          params: {
            redirectParams: {
              name: to.name,
              path: to.fullPath,
              params: to.params
            }
          }
        });
      } else {
        if (to.matched.some(record => record.meta.isAdmin)) {
          if (store && store.getters.isSsoAuthenticated == true) {
            fetchDataAndNext(to, from, next);
          } else {
            next({
              name: "userboard"
            });
          }
        } else {
          fetchDataAndNext(to, from, next);
        }
      }
    } else {
      fetchDataAndNext(to, from, next);
    }
  }
});

router.afterEach(to => {
  if (to.query.scrollTo) {
    let attempts = 0;
    const tryScroll = () => {
      const els = document.querySelectorAll(
        `#category-block-${to.query.scrollTo}`
      );
      const el = Array.from(els).find(e => e.offsetParent !== null);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 140;
        window.scrollTo({ top, behavior: "smooth", block: "center" });
      } else if (attempts++ < 10) {
        setTimeout(tryScroll, 300);
      }
    };
    setTimeout(tryScroll, 300);
  }
});

Vue.use(VueRouterBackButton, { router });

export default router;
